/* eslint-disable */
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { FieldPreviewComponent } from "../../field-preview.component";
import { Datetime } from "./datetime";

@Component({
    selector: "datetime",
    templateUrl: "./datetime.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeComponent extends FieldPreviewComponent implements OnInit, OnDestroy {
    constructor(private _changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.field.onChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((changed) => {
            this._changeDetector.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get datetime() {
        return this.field as Datetime;
    }
}
